import { render, staticRenderFns } from "./ClosedTickets.vue?vue&type=template&id=26e10f24&scoped=true&"
import script from "./ClosedTickets.vue?vue&type=script&lang=js&"
export * from "./ClosedTickets.vue?vue&type=script&lang=js&"
import style1 from "./ClosedTickets.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e10f24",
  null
  
)

export default component.exports